.vehicle-ted__subheader {
  @apply text-base font-bold mt-5 mb-4 font-ico-body text-ico-heading;
}

.vehicle-ted__options-container {
  @apply flex flex-row flex-wrap items-start w-full gap-2 md:gap-4;
}
